/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DashboardDefinitionVersion extends models.BaseDefinitionVersion {
    getFixupPrototypeFunction() { return DashboardDefinitionVersion.fixupPrototype; }

    static newInstance(model: Partial<DashboardDefinitionVersion>): DashboardDefinitionVersion {
        let obj = Object.assign(new DashboardDefinitionVersion(), model);
        DashboardDefinitionVersion.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DashboardDefinitionVersion>): DashboardDefinitionVersion {
        if (!model) return null;
        return DashboardDefinitionVersion.newInstance(<DashboardDefinitionVersion> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DashboardDefinitionVersion) {
        if (!obj) return;

        models.DashboardDefinitionVersion.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DashboardDefinitionVersion): boolean {
        if (models.BaseDefinitionVersion.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, DashboardDefinitionVersion.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.details) {
            models.DashboardConfiguration.fixupPrototype(this.details);
        }
    }

    /**
     * Details of the version
     */
    details: models.DashboardConfiguration;

}
